import React, { useState, useEffect } from "react";
import { apiRequest } from "../api";
import countries from "../data/countries.json";

const AddEventModal = ({ tourId, event, onClose, onSave }) => {
    const [name, setName] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [formId, setFormId] = useState("");
    const [crmId, setCrmId] = useState("");
    const [eventDate, setEventDate] = useState(""); // Added state for event date
    const [assignedUserId, setAssignedUserId] = useState(""); // New state for assigned user
    const [forms, setForms] = useState([]);
    const [users, setUsers] = useState([]); // New state for users
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const universityId = localStorage.getItem("universityId");
    const token = localStorage.getItem("token"); // Retrieve token from local storage

    // Fetch forms on mount
    useEffect(() => {
        const fetchForms = async () => {
            const url = `${apiUrl}/forms/${universityId}`;
            try {
                const data = await apiRequest(url, "GET", null, token);
                setForms(data);
            } catch (error) {
                console.error("Error fetching forms:", error);
                setFeedbackMessage("Failed to fetch forms. Please try again.");
            }
        };
        fetchForms();
    }, [universityId, apiUrl, token]);

    // Fetch users for assignment dropdown
    useEffect(() => {
        const fetchUsers = async () => {
            const url = `${apiUrl}/events/users`;
            try {
                const data = await apiRequest(url, "GET", null, token);
                setUsers(data.users || []);
            } catch (error) {
                console.error("Error fetching users:", error);
                // Don't show error message for users as it's optional
            }
        };
        fetchUsers();
    }, [apiUrl, token]);

    // Populate modal fields if editing
    useEffect(() => {
        if (event) {
            setName(event.name);
            setCity(event.city);
            setCountry(event.country || "");
            setCrmId(event.crm_id);
            setFormId(event.form_id);
            setEventDate(event.event_date || "");
            setAssignedUserId(event.assigned_user_id || "");
        } else {
            setName("");
            setCity("");
            setCountry("");
            setCrmId("");
            setFormId("");
            setEventDate("");
            setAssignedUserId("");
        }
    }, [event]);

    const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
        name,
        city: city,
        country: country || null,
        event_date: eventDate,
        tour_id: tourId,
        form_id: formId,
        crm_id: crmId,
        assigned_user_id: assignedUserId || null, // Add assigned user to payload
    };

    const url = event
        ? `${apiUrl}/events/${event.id}`
        : `${apiUrl}/events`;
    const method = event ? "PUT" : "POST";

    try {
        const data = await apiRequest(url, method, payload, token);
        console.log(`Event ${event ? "updated" : "created"} successfully:`, data);
        setFeedbackMessage(`Event ${event ? "updated" : "created"} successfully!`);
        setTimeout(() => {
            setFeedbackMessage(null);
            onSave();
            onClose();
        }, 2000);
    } catch (error) {
        console.error(`Error ${event ? "updating" : "creating"} event:`, error);
        setFeedbackMessage(`Failed to ${event ? "update" : "create"} event. Please try again.`);
    }
};

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                }}
            >
                <h4>{event ? "Edit Event" : "Add New Event"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Event Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Event City:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Event Country (Optional):</label>
                        <select
                            className="form-control"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                        >
                            <option value="">-- Select a Country --</option>
                            {countries.map((c) => (
                                <option key={c.name} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Event Date:</label>
                        <input
                            type="date"
                            className="form-control"
                            value={eventDate}
                            onChange={(e) => setEventDate(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Select Form:</label>
                        <select
                            className="form-control"
                            value={formId}
                            onChange={(e) => setFormId(e.target.value)}
                            required
                        >
                            <option value="" disabled>
                                -- Select a Form --
                            </option>
                            {forms.map((form) => (
                                <option key={form.id} value={form.id}>
                                    {form.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>CRM ID[Optional]:</label>
                        <input
                            type="input"
                            className="form-control"
                            value={crmId}
                            onChange={(e) => setCrmId(e.target.value)}

                        />
                    </div>
                    <div className="form-group">
                        <label>Assign User (Optional):</label>
                        <select
                            className="form-control"
                            value={assignedUserId}
                            onChange={(e) => setAssignedUserId(e.target.value)}
                        >
                            <option value="">-- No Assignment --</option>
                            {users.map((user) => (
                                <option key={user.id} value={user.id}>
                                    {user.name} ({user.role})
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">
                            {event ? "Update" : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
                {feedbackMessage && (
                    <p
                        style={{
                            marginTop: "10px",
                            color: feedbackMessage.includes("successfully") ? "green" : "red",
                        }}
                    >
                        {feedbackMessage}
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddEventModal;